export const isInViewport = el => {
  const { top } = el.getBoundingClientRect()
  const offset = 100
  const isInView = top < offset

  return isInView
}
